import React, {useEffect, useState} from "react";

import URLS from "../../../config/navigation";
import {ReactComponent as CopyIcon} from '../../../assets/img/copyIcon.svg';
import {useSelector} from "react-redux";
import {selectProfileUrl} from "../../../store/selectors/Profile";
import Textbox from '../../Common/Textbox'
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Toast from "../../Common/Toast";
import ToastMessage from "../../Common/ToastMessage";
const PreviewUserUrl = () => {

  const userProfileUrl = useSelector(selectProfileUrl)
  const [publicUrl, setPublicUrl] = useState('');

  useEffect(() => {
    if(userProfileUrl) {
      setPublicUrl(userProfileUrl.toLowerCase())
    }
  }, [userProfileUrl])

  const handleClick = () => {
    var copyText = document.getElementById("profle-url");
    copyText.focus()
    copyText.select();
    copyText.setSelectionRange(0, 99999); /* For mobile devices */
    navigator.clipboard.writeText("https://"+copyText.value);
    Toast(ToastMessage(8), "success")
  };

  return (
    <div className={"previewUrlContainer"}>
      <div className={"previewUrlWrapper"}>
        { userProfileUrl &&
          (<div className={"publicUrlContainer"}>
             <div className={"inputGroup"}>
                 <Textbox tName="publicUrl" handleClick={handleClick} loading={true} htmlFor="profle-url" type="text"
                  additionClass={"inputUrl BODY_MEDIUM"}  value={`teachon.org/${publicUrl}`}

                  endAdornment={
                    <InputAdornment onClick={handleClick} position="end">
                      <IconButton
                        aria-label="toggle password visibility"

                        edge="end"
                      >
                      <CopyIcon fontSize={22} />
                      </IconButton>
                    </InputAdornment>
                  } />


              </div>
          </div>)
        }
        <span className={"description EMPHASIS_LARGE"}>
          {
            !userProfileUrl ? (
              <>
                You need to setup your profile!
                <a className={"linkToEdit EMPHASIS_LARGE"} href={URLS.PUBLIC.SETUP}>
                  Setup your profile.
                </a>
              </>
            ) : (
              <>
                What you see below if how students will see your profile page.
                <a className={"linkToEdit EMPHASIS_LARGE"} href={URLS.SETTINGS.EDIT}>
                  Edit your profile.
                </a>
              </>
              )
          }

        </span>
      </div>
    </div>
  );
}

export default PreviewUserUrl;
